import { useState } from "react";
import { Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { IoArrowForward } from "react-icons/io5";
import secondaryFont from "@/utils/secondaryFont";
import axios from "axios";
import { useCfStore } from "@/components/CfTurnstile";
import { addToDataLayer } from "@/utils/addToDataLayer";
import FormSubmissionMessage from "../FormSubmissionMessage";

const OfferForm = ({ page = "", event = "Get" }) => {
  const [submitMessage, setSubmitMessage] = useState({
    text: "",
    phoneLink: "",
  });
  const { token, reset } = useCfStore();

  const [success, setSuccess] = useState("");
  const [fail, setFail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    if (!token) {
      window.alert("Checking for humans. Please try again in a minute.");
      setSubmitting(false);
      return;
    }

    await axios
      .post("/api/hubspot", { formData })
      .then(() => null)
      .catch(() => null);

    await axios
      .post("/api/submit-form", {
        fields: [
          { key: "First Name", value: formData?.firstName },
          { key: "Email", value: formData?.email },
          { key: "Phone", value: formData?.phone },
          { key: "Message", value: formData?.message },
        ],
        page,
        firstName: formData?.firstName,
        email: formData?.email,
        event,
        recaptchaToken: token,
      })
      .then((res) => {
        if (res?.status === 200) {
          setSubmitMessage({
            text: "Thank you for your inquiry. We will get back to you soon over an email or via a call. If you need assistance with anything else,",
            phoneLink: "(212) 913-9141",
          });
          setSuccess(true);
          addToDataLayer("Form Submission Get A Loan");
          setFormData({
            firstName: "",
            email: "",
            phone: "",
            message: "",
          });
        } else {
          setSubmitMessage({
            text: "Submisison unsuccessful. Please try again",
            phoneLink: "",
          });
          setFail(true);
        }
      })
      .catch((e) => {
        setSubmitMessage({
          text: "Submisison unsuccessful. Please try again",
          phoneLink: "",
        });
        setFail(true);
        console.log(e);
      })
      .finally(() => {
        setSubmitting(false);
        reset();
      });
  };

  return (
    <Form onSubmit={handleSubmit}>
      {submitMessage?.text && (
        <FormSubmissionMessage
          fail={fail}
          success={success}
          submitMessage={submitMessage}
        />
      )}
      {!submitMessage?.text && (
        <>
          <FloatingLabel
            controlId="floatingInputName"
            label="Full name"
            className={` mb-3`}
          >
            <Form.Control
              type="text"
              placeholder="Full name"
              value={formData?.firstName}
              required={true}
              onChange={(e) => {
                setFormData({ ...formData, firstName: e.target.value });
              }}
            />
          </FloatingLabel>
          <Row className="mb-md-3">
            <Col xs={6} md={12}>
              <FloatingLabel
                controlId="floatingInputEmail"
                label="Email"
                className={` mb-3`}
              >
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={formData?.email}
                  required={true}
                  onChange={(e) => {
                    setFormData({ ...formData, email: e.target.value });
                  }}
                />
              </FloatingLabel>
            </Col>
            <Col xs={6} md={12}>
              <FloatingLabel
                controlId="floatingInputPhone"
                label="Phone number"
                className={` mb-3 mb-md-0`}
              >
                <Form.Control
                  type="tel"
                  placeholder="Phone number"
                  required={true}
                  value={formData?.phone}
                  minLength="8"
                  maxLength="12"
                  onChange={(e) => {
                    setFormData({ ...formData, phone: e.target.value });
                  }}
                />
              </FloatingLabel>
            </Col>
          </Row>
          <FloatingLabel
            controlId="floatingInputItems"
            label="Message & items descriptions"
            className={` mb-3`}
          >
            <Form.Control
              as="textarea"
              placeholder="Message & items descriptions"
              style={{ height: "100px" }}
              value={formData?.message}
              onChange={(e) => {
                setFormData({ ...formData, message: e.target.value });
              }}
            />
          </FloatingLabel>
          <button
            type="submit"
            disabled={submitting}
            className={`btn btn-primary w-100 justify-content-center ${secondaryFont}`}
          >
            Get a loan offer now{" "}
            <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
          </button>
        </>
      )}
    </Form>
  );
};

export default OfferForm;
